export interface CountryItem {
    name: string;
    code: string;
};